"use client";

import React from "react";

//Types
import { FormProps } from "@/types";

//Styles
import * as S from "./styles";

const FormComponent: React.FC<FormProps> = ({
  className,
  onSubmit,
  children,
}) => {
  return (
    <S.Form onSubmit={onSubmit} className={className}>
      {children}
    </S.Form>
  );
};

export default FormComponent;
